<template>
    <AdSection1
        :imageSrc="pic1Src"
        title="تبلیغات بنری؛ پل ارتباطی شما با هزاران مخاطب"
        text="هدف اصلی تبلیغات بنری افزایش آگاهی از برند و جذب ترافیک است.
        با طراحی جذاب و پیام های مؤثر، تبلیغ بنری میتواند توجه کاربران زیادی را جلب کرده و آنها را به تعامل با سایت شما ترغیب کند."
        imageAnimation="fade-right"
    >
    </AdSection1>
    <AdSection2
        :imageSrc="pic2Src"
        count=" نمایش 10,000,000,000+"
        text="تبلیغ بنری موفق با آن کلیک"
    >
    </AdSection2>

    <AdSection3
        title="تبلیغات بنری"
        text="تبلیغات بنری در بخش های مشخص و پرمخاطب وب سایت ها، به معرفی برند محصولات یا خدمات میپردازد. جهت اثربخشی بیشتر، بهتر است طراحی بنر جذاب باشد و از پیام های کوتاه و تأثیرگذار استفاده شود تا توجه مخاطبان را جلب کرده و آنها را به بازدید یا تعامل تشویق کنید. جذب بازدید بیشتر نسبت به روشهای دیگر، از مزایای کلیدی این تبلیغات است."
        videoSrc="https://ifilo.net/embed/KhJowhq"
    >
    </AdSection3>

     <AdSection4
        :imageSrc="pic3Src"
        title="چرا تبلیغات بنری؟"
        :benefits="benefits"
    >
    </AdSection4>

    <AdContentCard
        :imageSrc="pic4Src"
        title="تبلیغات بنری مناسب چه اهدافی است؟"
        text="آن کلیک، تبلیغات بنری را به کسانی پیشنهاد می دهد که به دنبال افزایش آگاهی از برند و جذب ترافیک هدفمند به وب سایت خود هستند. این روش برای برندهایی که میخواهند در ذهن مخاطبان ماندگار شوند و تعامل بیشتری با آنها ایجاد کنند، انتخابی ایده آل است."
    >
    </AdContentCard>

    <AdTariff
    title="تعرفه تبلیغات بنری"
    text="در آن کلیک با کمترین بودجه می توانید تبلیغاتی با اثربخشی بالا داشته باشید. تعرفه تبلیغات بنری به ازای کلیک بر روی بنر شما محاسبه می شود. "
    :imageSrc="pic5Src"
    >
    </AdTariff>

    <AdRoadmap></AdRoadmap>

    <AdConsult
    text="اگر آماده اید با تبلیغات بنری، برند خود را به هزاران کاربر معرفی کنید، همین حالا شروع کنید یا برای دریافت راهنمایی تخصصی، با مشاوران آن کلیک در ارتباط باشید."
    >
    </AdConsult>

    <FAQ :faqList="faqList"></FAQ>
</template>

<script>
    import AdSection1 from './AdSection1';
    import AdSection2 from './AdSection2';
    import AdSection3 from './AdSection3';
    import AdSection4 from './AdSection4';
    import AdContentCard from './AdContentCard';
    import AdTariff from './AdTariff';
    import AdRoadmap from './AdRoadmap';
    import AdConsult from './AdConsult';
    import FAQ from './FAQ';

    import bannerAdPic1 from '@/assets/images/bannerAd-pic1.png';
    import nativeAdPic2 from '@/assets/images/nativeAd-pic2.png';
    import bannerAdPic3 from '@/assets/images/bannerAd-pic3.png';
    import bannerAdPic4 from '@/assets/images/bannerAd-pic4.png';
    import bannerAdPic5 from '@/assets/images/bannerAd-pic5.png';

    import {ref, inject, onMounted} from 'vue';
    export default {
        name: "BannerAds",
    components: {
    AdSection1,
    AdSection2,
    AdSection3,
    AdSection4,
    AdContentCard,
    AdTariff,
    AdRoadmap,
    AdConsult,
    FAQ,
    },
    setup() {

        const benefits = ref([
        "افزایش آگاهی از برند",
        "جلب توجه سریع",
        "هدایت ترافیک به وب سایت",
        "افزایش فروش و تعامل",
        ]);

        const faqList = ref([
        {
            q: "تبلیغات بنری چیست؟",
            a: "تبلیغات بنری، به تصاویر ثابت یا متحرکی گفته می شود که در جایگاه های مشخص و پرمخاطب وب سایت نمایش داده می شود."
        },
        {
            q: "  تبلیغات بنری برای چه کسب و کارهایی مناسب است؟",
            a: "این نوع از تبلیغات برای کسب و کارهایی که به دنبال افزایش آگاهی از برند و جذب ترافیک هستند، بیشتری بازدهی را دارد."
        },
        {
            q: "هزینه ثبت تبلیغات بنری در آن کلیک چقدر است؟",
            a: `تعرفه تبلیغات بنری به ازای کلیک محاسبه می شود.جزییات بیشتر: <a href="/tariff">تعرفه ثبت تبلیغات</a>`
        },
        {
            q: " برای ثبت تبلیغ بنری در آن کلیک چه کنیم؟",
            a: "در آن کلیک ثبت نام کرده و اولین کمپین خود را ایجاد کنید."
        },
        ]);

        const updateMetaTag = inject('updateMetaTag');
        const updateOGTag = inject('updateOGTag');
        const updateCanonicalLink = inject('updateCanonicalLink');

        onMounted (() => {
            updateMetaTag('title', ' تبلیغات بنری؛ نمایش هدفمند بنر در سایت های پربازدید | آن کلیک');
            updateMetaTag('description', ' با تبلیغات بنری آن کلیک، برند خود را در سایت های پربازدید نمایش دهید. هدف گیری دقیق، فرمت های متنوع، و بازدهی قابل اندازه گیری برای رشد کسب و کار شما.');
            updateOGTag('title', 'تبلیغات بنری؛ نمایش هدفمند بنر در سایت های پربازدید | آن کلیک');
            updateOGTag('description', 'با تبلیغات بنری آن کلیک، برند خود را در سایت های پربازدید نمایش دهید. هدف گیری دقیق، فرمت های متنوع، و بازدهی قابل اندازه گیری برای رشد کسب و کار شما');
            updateOGTag('type', 'website');
            updateOGTag('image', require('@/assets/images/onclick.png'));
            updateCanonicalLink('https://onclick.ir/ads/banner');
        });

        return {
             pic1Src: bannerAdPic1,
             pic2Src: nativeAdPic2,
             pic3Src: bannerAdPic3,
             pic4Src: bannerAdPic4,
             pic5Src: bannerAdPic5,
             benefits,
             faqList,
        }

    }
};
</script>
